import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div<{ maxWidth: string | undefined; maxHeight: number | undefined }>`
  background-color: #e8e9ea;
  box-sizing: border-box;
  width: 90vw;
  border-radius: 8px;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '536px')};
  max-height: ${(props) => (props.maxHeight ? `${props.maxHeight}px` : '90vh')};
  overflow: auto;
`;

const Content = styled.div<{ height: number }>`
  transition: opacity 0.2s ease-in-out;
  min-height: ${({ height }) => height}px;
  max-height: 80vh;
  flex-flow: column nowrap;
  animation: fade-in 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
`;

const Title = styled.div`
  text-align: center;
  color: #005d68;
  font-size: 28px;
  font-weight: bold;
  padding: 40px 48px;
  font-size: 32px;
  letter-spacing: 0.48px;
  line-height: 32px;
`;

interface Props {
  title: string;
  maxWidth?: string;
  height?: number;
  maxHeight?: number;
  small?: boolean;
}

const Modal: React.FunctionComponent<Props> = ({
  title,
  maxWidth,
  children,
  height = 601,
  small = false,
  maxHeight,
}) => {
  return (
    <Wrapper maxHeight={maxHeight} maxWidth={maxWidth}>
      <Content height={small ? 440 : height}>
        <Title>{title}</Title>
        {children}
      </Content>
    </Wrapper>
  );
};

export default Modal;
